// Module
var code = "<span class=\"preformatted-text\">{{$ctrl.value}}</span>";
// Exports
var _module_exports =code;;
var path = '/ng-templates/src/commons/components/kp-preformatted-text/kp-preformatted-text.tpl.pug';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;